import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";
import { api } from "@/lib/api";

const PublicLayout = () => {
  const [siteSettings, setSiteSettings] = useState(null);

  useEffect(() => {
    api.get("/site-settings").then((r) => setSiteSettings(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white text-[#0A1128]">
      <Header siteSettings={siteSettings} />
      <main className="flex-1 pt-[72px] md:pt-[88px]">
        <Outlet context={{ siteSettings }} />
      </main>
      <Footer siteSettings={siteSettings} />
      <WhatsAppFloat phone={siteSettings?.contact?.whatsapp || siteSettings?.social_links?.whatsapp} />
    </div>
  );
};

export default PublicLayout;
